import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDEU_tacG88PctDqCpciIEM4R0eHm9L9mU",
  authDomain: "ionice-845d6.firebaseapp.com",
  databaseURL: "https://ionice-845d6-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ionice-845d6",
  storageBucket: "ionice-845d6.firebasestorage.app",
  messagingSenderId: "380025148508",
  appId: "1:380025148508:web:2c21514038f718dd9c0299",
  measurementId: "G-SZ3RH9ZG7R"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const rtdb = getDatabase(app);
